'use client';

import { cn, toast } from '@baseball-near-you/ui';
import { SiFacebook, SiX } from '@icons-pack/react-simple-icons';
import { isServer } from '@tanstack/react-query';
import { CopyCheck, CopyIcon, MailIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

export function ShareSocials(props: { title: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  if (isServer) {
    return null;
  }

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <h4 className="font-bold! text-lg!">Like it? Share it!</h4>
      <div className="flex items-center justify-center gap-x-4">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${
            globalThis.window ? window.location.href : ''
          }`}
          target="_blank"
          rel="noreferrer"
          className="m-0! flex items-center justify-center"
        >
          <SiFacebook
            className={cn(
              'size-12 rounded-full bg-red p-3 pr-3.5 text-white transition-transform',
              'hover:scale-105 active:scale-95'
            )}
          />
        </a>
        <a
          href={`https://x.com/intent/tweet?url=${encodeURIComponent(
            window ? window.location.href : ''
          )}&text=${encodeURIComponent(props.title)}`}
          target="_blank"
          rel="noreferrer"
          className="m-0! flex items-center justify-center"
        >
          <SiX
            className={cn(
              'size-12 rounded-full bg-red p-3 pl-3.5 text-white transition-transform',
              'hover:scale-105 active:scale-95'
            )}
          />
        </a>
        <a
          href={`mailto:?subject=${props.title}&body=${
            window ? window.location.href : ''
          }`}
          target="_blank"
          rel="noreferrer"
          className="m-0! flex items-center justify-center"
        >
          <MailIcon
            className={cn(
              'size-12 rounded-full bg-red p-3 pl-3.5 text-white transition-transform',
              'hover:scale-105 active:scale-95'
            )}
          />
        </a>
        <CopyToClipboard
          text={window.location.href}
          onCopy={() => {
            setCopied(true);
            toast.success('Blog copied to clipboard!');
          }}
        >
          <button
            className={cn(
              '!m-0 flex size-12 items-center justify-center rounded-full transition-all',
              !copied && 'hover:scale-105 active:scale-95',
              copied
                ? 'bg-green-500 text-white hover:bg-green-600'
                : 'bg-red text-white'
            )}
            type="button"
          >
            {copied ? <CopyCheck /> : <CopyIcon />}
          </button>
        </CopyToClipboard>
      </div>
    </div>
  );
}
